
const regexps = {
  domain: /^[a-zA-Z0-9]+$/,
  name: /^.{1,30}$/,
  email: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/
}


const errClassToggle = ( el, bool ) => {
  const func = bool ? 'add' : 'remove'
  el.classList[ func ]( 'has-error')
  el.parentElement.classList[ func ]( 'has-error')
}


function validate( el, type ) {
  let val = el.value
  let valid = isValid( val, type )
	let minLengthValid = isMinLengthValid( el, val )
  errClassToggle( el, ( (!valid) || (!minLengthValid) ))
  return valid ? val : null
}



function isValid(val, type) {
  return regexps[ type ].test( val )
}


function isMinLengthValid( el, val ) {
	if( el.hasAttribute( 'minlength' ) ) {
		let currentLength = val.length
		if ( el.getAttribute( 'minlength' ) <= currentLength ) {
			return true
		}
		return false
	}
	return true
}





validate.isValid = isValid





export default validate




// WEBPACK FOOTER //
// ./src/validator/validator.js